import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { HolidaySearchParams } from '../../../booking-flow/holiday/holiday-search-page/interfaces/holiday-search-params';
import { Occupancy } from '../../../shared/interfaces/occupancy';
import { IDestinationBoxElement } from '../../interfaces/idestination-box-element';
import { IEngineParamChange } from '../../interfaces/iengine-param-change';
import { EngineTabTypes } from '../../models/engine-tab-types.enum';
import { WidgetService } from 'src/app/modules/shared/services/widget.service';
import * as dayjs from 'dayjs';
import { MobileService } from 'src/app/modules/shared/services/mobile.service';
import { BookingService } from 'src/app/modules/shared/services/booking.service';

@Component({
  selector: 'app-engine-tour',
  templateUrl: './engine-tour.component.html',
  styleUrls: ['./engine-tour.component.scss']
})
export class EngineTourComponent implements OnInit, OnDestroy {

  @Input() holidaySearchParams: HolidaySearchParams;
  @Input() engineTabType: EngineTabTypes;
  onlyNetQuotes: Observable<boolean>;
  onlyCustomHoliday: Observable<boolean>;
  isB2B$: Observable<boolean>;

  constructor (
    private _widgetService: WidgetService,
    private _router: Router,
    private _mobileService: MobileService,
    private _bookingService: BookingService,
  ) { }

  selectedDestination: IEngineParamChange<IDestinationBoxElement>;
  selectedAirport: IEngineParamChange<(number | string)[]>;
  selectedDate: IEngineParamChange<NgbDateStruct>;
  selectedOccupancy: IEngineParamChange<Occupancy>;
  selectedDepartureDate: any;
  minDate = dayjs(new Date());
  isMobile$: Observable<boolean>;
  selectedDateString: string;

  aiportSubscription: Subscription;
  widgetSubscription: Subscription;

  ngOnInit(): void {
    this.isMobile$ = this._mobileService.isMobile();
  }

  onSelectedDestination(selectedDestination: IEngineParamChange<IDestinationBoxElement>): void {
    this.selectedDestination = selectedDestination;
  }

  onSelectedDate(selectedDate: IEngineParamChange<NgbDateStruct>): void {
    this.selectedDate = selectedDate;

    if (this.selectedDate?.value) {
      this.selectedDateString = `${this.selectedDate.value.year}-${String(this.selectedDate.value.month).padStart(2, '0')}-${String(this.selectedDate.value.day).padStart(2, '0')}`;
    }
  }

  onInputSelection(): void {
    this.widgetSubscription = this._widgetService.isWidget().subscribe(e => {
      if (!e) {
        document.querySelector('#searchEngine').scrollIntoView();
      }
    });
    this.widgetSubscription.unsubscribe();
  }

  searchHoliday(): void {
    let route = '';
    const occupancyString = this._bookingService.getAgesString();
    if (this.selectedDate){
      route = `/${this.engineTabType}/ricerca/eta/${occupancyString}/destinazione/${this.selectedDestination.value.id}/il/${this.selectedDateString}`;
    } else {
      route = `/${this.engineTabType}/ricerca/eta/${occupancyString}/destinazione/${this.selectedDestination.value.id}`;
    }
    this._router.navigate([route]);
  }

  ngOnDestroy(): void {
    this.aiportSubscription?.unsubscribe();
  }
}
